import { z } from "zod";
import { createOptionsFrom } from "@/lib/common/Option";

export const EmblemSetLabels = {
	SpecialEmblems: "Special Emblems",
	Set2024Originals: "Set: 2024 Originals",
	Set2025Supplementary: "Set: 2025 Supplementary",
	Set2026Frontier: "Set: 2026 Frontier"
} as const;

export type EmblemSetType = keyof typeof EmblemSetLabels;

export const EmblemSetOptions = createOptionsFrom(EmblemSetLabels);

export const EmblemSetSchema = z.enum(
	Object.keys(EmblemSetLabels) as EmblemSetType[]
);
